import { render, staticRenderFns } from "./Remote.vue?vue&type=template&id=66f77d3d&lang=pug"
import script from "./Remote.vue?vue&type=script&lang=js"
export * from "./Remote.vue?vue&type=script&lang=js"
import style0 from "./Remote.vue?vue&type=style&index=0&id=66f77d3d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports